import { render, staticRenderFns } from "./real.vue?vue&type=template&id=6b7b1371&scoped=true"
import script from "./real.vue?vue&type=script&lang=js"
export * from "./real.vue?vue&type=script&lang=js"
import style0 from "./real.vue?vue&type=style&index=0&id=6b7b1371&prod&scoped=true&lang=css"
import style1 from "./real.vue?vue&type=style&index=1&id=6b7b1371&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7b1371",
  null
  
)

export default component.exports